/**
 * Backend URL Configuration
 * 
 * Auto-detects environment:
 * - localhost → uses http://localhost:5000 (direct to local backend)
 * - testing.yovotrip.com → uses https://api.yovotrip.com (testing backend)
 * - production (yovotrip.com) → uses https://backend.yovotrip.com (production backend)
 */

const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const isTesting = typeof window !== 'undefined' &&
  window.location.hostname === 'testing.yovotrip.com';

export const BACKEND_URL = isLocalhost
  ? 'http://localhost:5000'
  : isTesting
    ? 'https://api.yovotrip.com'
    : 'https://backend.yovotrip.com';

export const BACKEND_URL_FALLBACK = BACKEND_URL;

export const API_BASE_URL = `${BACKEND_URL}/api`;
export const API_BASE_URL_FALLBACK = `${BACKEND_URL_FALLBACK}/api`;
